<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="getAll">
			<el-tab-pane label="未完成" name="未完成">
				<wpd ref="wpd"></wpd>
			</el-tab-pane>
			<el-tab-pane label="进行中" name="已完成">
				<ypd ref="ypd"></ypd>
			</el-tab-pane>
			<el-tab-pane label="已完成" name="已结束">
				<yjs ref="yjs"></yjs>
			</el-tab-pane>
			<el-tab-pane label="已取消" name="已取消">
				<yqx ref="yqx"></yqx>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import wpd from "./wpd.vue"
import ypd from "./ypd.vue"
import yjs from "./yjs.vue"
import yqx from "./yqx.vue"
export default {
	components: {
		wpd,
		ypd,
		yjs,
		yqx
	},
	data() {
		return {
			activeName: "未完成"
		}
	},
	methods: {
		getAll() {
			if (this.activeName == "未完成") {
				this.$refs.wpd.getAll();
			}
			else if (this.activeName == "已完成") {
				this.$refs.ypd.getAll();

			}
			else if (this.activeName == "已结束") {
				this.$refs.yjs.getAll();

			}
			else if (this.activeName == "已取消") {
				this.$refs.yqx.getAll();

			}
		},
	}

}
</script>

<style></style>
